import PropTypes from 'prop-types';
import classnames from 'classnames';
import RoundedImage from '../../components/RoundedImage';
import styles from './profileInfo.module.less';
import EditProfileImage from '../edit-profile-image/EditProfileImage';
import VisibleIf from '../../components/VisibleIf';
import TrackEventLink from '../../components/track-event-link/TrackEventLink';
import Image from '../../components/image/Image';

const imageDiv = (className, src, size, canEditProfileImage) => (
    <div className={className}>
        {canEditProfileImage ? (
            <EditProfileImage imageSize={`${size}px`} className={styles.border} />
        ) : (
            <RoundedImage src={src} size={`${size}px`} className={styles.roundedImage} />
        )}
    </div>
);

const ProfileInfo = (props) => {
    const {
        title,
        subtitle,
        titleClass,
        imageClassNameLeft,
        imageClassNameRight,
        imageSize,
        imageSrcLeft,
        imageSrcRight,
        isEditable,
        textContainerClassName,
        badgeTitle,
        verified,
        urlForOrganizationNavigation,
        urlForProfileNavigation,
        hideBadge,
        hideLogo,
    } = props;

    let profileName;

    if (urlForOrganizationNavigation) {
        profileName = (
            <TrackEventLink
                className={styles.link}
                to={urlForOrganizationNavigation}
                action="org-clicked"
                category="org-navigation"
            >
                {title}
            </TrackEventLink>
        );
    } else if (urlForProfileNavigation) {
        profileName = (
            <TrackEventLink
                className={styles.link}
                to={urlForOrganizationNavigation}
                action="profile-clicked"
                category="profile-navigation"
            >
                {title}
            </TrackEventLink>
        );
    } else {
        profileName = title;
    }

    return (
        <div className={styles.container}>
            <VisibleIf isVisible={!hideLogo}>
                <div className={styles.imagesContainer}>
                    {imageDiv(imageClassNameLeft, imageSrcLeft, imageSize, isEditable)}
                    {imageSrcRight ? imageDiv(imageClassNameRight, imageSrcRight, imageSize, false) : null}
                </div>
            </VisibleIf>
            <div className={classnames(styles.textContainer, textContainerClassName)}>
                <div className={`${styles.title} ${titleClass}`}>
                    {!hideBadge && (
                        <>
                            {verified && (
                                <Image
                                    src="verifisert-ikon.svg"
                                    title={badgeTitle}
                                    alt="Verifisert"
                                    className={styles.verificationBadge}
                                />
                            )}

                            {!verified && (
                                <Image
                                    src="ikke-verifisert-ikon.svg"
                                    title={badgeTitle}
                                    alt="Ikke verifisert"
                                    className={styles.verificationBadge}
                                />
                            )}
                        </>
                    )}
                    {profileName}
                </div>
                {!verified && !subtitle && <div className={styles.subtitle}>{badgeTitle}</div>}
                <div className={styles.subtitle}>{subtitle}</div>
            </div>
        </div>
    );
};

ProfileInfo.defaultProps = {
    titleClass: '',
    imageClassNameLeft: '',
    imageClassNameRight: '',
    imageSrcLeft: '',
    imageSrcRight: '',
    subtitle: '',
    badgeTitle: null,
    isEditable: false,
    verified: false,
    textContainerClassName: '',
    hideBadge: false,
    hideLogo: false,
    imageSize: 40,
};

ProfileInfo.propTypes = {
    imageSize: PropTypes.number,
    imageClassNameLeft: PropTypes.string,
    imageClassNameRight: PropTypes.string,
    imageSrcLeft: PropTypes.string,
    imageSrcRight: PropTypes.string,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    badgeTitle: PropTypes.string,
    isEditable: PropTypes.bool,
    verified: PropTypes.bool,
    textContainerClassName: PropTypes.string,
    hideBadge: PropTypes.bool,
    hideLogo: PropTypes.bool,
};

export default ProfileInfo;
